export class PsQrMachineToken {

    _qrInfo // string

    constructor(
        qrInfo,
    ) {
        this._qrInfo = qrInfo;
    }

    static fromApiQrMachineToken(qrMachine) {
        return new this(qrMachine.qr_info);
    }

    qrInfo() {
        return this._qrInfo;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/PsQrMachineToken.js